import { FC, useCallback, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useColumnSelector } from '../../../providers/ColumnSelectorProvider';
import { SearchInput } from '../../../../../CoreComponents/base/SearchInput';
import { getGroupMap } from '../../../providers/column-utils';
import { GroupColumnMenu } from './GroupColumnMenu';

const Wrapper = styled('section')`
  padding: 0 32px 0;
  margin: 0 auto;
`;

const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  padding: 24px;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 100;
`;

export const ColumnDataPtList: FC = () => {
  const { sortedColumns } = useColumnSelector();
  const [searchInput, setSearchInput] = useState('');

  const columnsByGroup = useMemo(() => {
    const filteredCols = sortedColumns.filter((col) =>
      col.displayName.toLowerCase().includes(searchInput.toLowerCase())
    );
    return getGroupMap(filteredCols);
  }, [sortedColumns, searchInput]);

  const sortedGroupNames = useMemo(() => {
    return Array.from(columnsByGroup.keys());
  }, [columnsByGroup]);

  const handleSearch = useCallback((input: string) => {
    setSearchInput(input);
  }, []);

  if (!sortedGroupNames) {
    return null;
  }

  return (
    <>
      <Header>
        <SearchInput
          style={{ width: 'min(420px, 50%)' }}
          placeholder='Search for data points'
          onChange={handleSearch}
          autoFocus
        />
      </Header>
      <Wrapper>
        {sortedGroupNames.map((group) => {
          const columnsInGroup = columnsByGroup.get(group) ?? [];

          if (columnsInGroup.length === 0) {
            return null;
          }

          return <GroupColumnMenu key={group} groupName={group} columns={columnsInGroup} />;
        })}
      </Wrapper>
    </>
  );
};
